import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import ClockIcon from '../../../atoms/icons/clock-icon';

import { Thumbnail } from '../thumbnail';
import { getDuration, secondsToHms } from '../../../../helpers/utils';

import './video-card.m.css';

export const VideoCard = ({ video = {}, imageWidth = '256', imageHeight = '144' }) => {
  const imageThumbnail = get(video, ['systemThumbnails', 0, 'url'], get(video, 'thumbnail_url'));

  return (
    <div styleName="card">
      <Thumbnail
        src={imageThumbnail}
        title={video.name}
        width={imageWidth}
        height={imageHeight}
        duration={video.duration}
      />

      <div>
        <h3 styleName="title" className="truncate-overflow">
          {video.name || video.title}
        </h3>
        <div styleName="time">
          <ClockIcon />
          <span>
            {secondsToHms(get(video, ['duration'], 0)) || getDuration(get(video, ['duration'], 0))}
          </span>
        </div>
      </div>
    </div>
  );
};

VideoCard.propTypes = {
  video: PropTypes.object,
  imageHeight: PropTypes.string,
  imageWidth: PropTypes.string
};
